import React, { useContext, useMemo } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import PortalAppSidebar from './ProductAppSidebar';
import {
  V3AppsContext,
  V3SelectedAppContext,
} from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/V3AppsProvider';

const MultiplePortalAppSideBar = ({ product }: { product: V3.Product }) => {
  const { availableProductApps } = useContext(V3AppsContext);
  const { appSlug } = useParams();
  const selectedApp = useMemo(() => {
    return availableProductApps.find(
      (app) => app.urlSlug === appSlug && product.appIds.includes(app.id),
    );
  }, [appSlug, availableProductApps, product.appIds]);

  if (!selectedApp) {
    return null;
  }

  return (
    <V3SelectedAppContext.Provider
      value={{ selectedProduct: product, selectedProductApp: selectedApp }}
    >
      <PortalAppSidebar />;
    </V3SelectedAppContext.Provider>
  );
};

const Gate = ({ product }: { product: V3.Product }) => {
  return (
    <Routes>
      <Route
        path={'/:appSlug/*'}
        element={<MultiplePortalAppSideBar product={product} />}
      />
    </Routes>
  );
};
export default Gate;
